/**
 * Created by fyzu on 25.07.16.
 */


var BasketService = (function () {

    'use strict';

    //************ Variables ************//
    var info = {
        count: 0,
        totalPrice: 0,
        countDishes: 0
    };

    var inOrderItems = {};

    //************ Functions ************//js-pickup-pay-type-radio

    function updateBasketInfo(count, price, maxFreeItems, standardFreeItems, itemsWithIds, countPositions) {
        info.count = count;
        info.totalPrice = price;
        if (count > 0) {
            $($('.js-basket-img').find('g').find('g')).attr('fill', '#eb1f40');
            $('.js-basket-info').show();
            $('.js-basket-info-count').text(countPositions);
            $('.js-basket-info-price').text(price);
        } else {
            $('.js-basket-info').hide();
        }

        $.each(standardFreeItems, function (id, count) {
            $.each(itemsWithIds, function (itemId, value) {
                if (id === itemId) {
                    $.each(inOrderItems, function (key, item) {
                        if (item.getId() === itemId) {
                            if (value.count > count) {
                                item.setCount(value.count);
                            } else {
                                item.setCount(count);
                            }
                        }
                    });
                }
            });
        });

        $.each(inOrderItems, function (key, item) {

            if (item.getIsAdditionalItem()) {
                if (maxFreeItems[item.getId()] === undefined) {
                    item.setCount(0);
                    if (info.count === 0) {
                        AppService.redirectToHome();
                    }
                } else {
                    var itemNotChanged = true;
                    $.each(maxFreeItems, function (id, count) {
                        if (item.getId() === id) {
                            itemNotChanged = false;
                            item.setMaxFreeCount(count);
                        }
                    });

                    if (itemNotChanged) {
                        item.setMaxFreeCount(0);
                    }
                }
            }
        });

        if (info.count === 0 && window.location.pathname === "/cart") {
            AppService.redirectToHome();
        }

        //updateAmountPrice();

        if ($('main.content').attr('data-general-tab') === 'basket') {
            OrderService.getBasketSession(null, null, null, null, null, null);
        }
    }

    function changePromoItem() {

        var itemId = $('input[name=itemId]:checked', '#js-submit-change-promo-item').val();
        var promoId = $('.js-cart-reward-item-promo-id').val();
        var position = $('.js-cart-reward-item-position').val();

        var data = {
            itemId: itemId,
            promoId: promoId,
            position: position
        };


        $.ajax({
            url: $(this).prop('action'),
            type: $(this).prop('method'),
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function () {
                $('#modalChangePromoItem').modal('hide');
                OrderService.getBasketSession(null, null, null, null, null, null);
            },
            error: function (response) {
            }
        });

        return false;
    }

    function cartResponse(response) {
        debug.log(response);
        if (response.code === "200") {
            updateBasketInfo(
                response.result.count,
                response.result.price,
                response.result.maxFreeItems,
                response.result.standardFreeItems,
                response.result.itemsWithIds,
                response.result.countPositions
            );
        } else {
            debug.log("Error: code - " + response.code + "; msg - " + response.msg);
        }
    }

    function requestAddItem(itemGroupId, itemId, countToAdd, addons = []) {
        $.post('/cart/add-item', {
            itemGroupId: itemGroupId,
            itemId: itemId,
            count: countToAdd,
            addons: addons.join(',')
        }, cartResponse);
    }

    function requestSet(itemGroupId, itemId, count, addons = []) {
        if(!addons)
            addons = [];
        $.post('/cart/set', {
            itemGroupId: itemGroupId,
            itemId: itemId,
            count: count,
            addons: addons.join(',')
        }, cartResponse);
    }

    function addWok(title, items, count, callback) {
        var composites = [];

        items.forEach(function (item, index) {
            var wokItem = {
                itemGroupId: item.itemGroupId,
                itemId: item.itemId,
                count: item.count
            };
            composites.push(wokItem);
        });

        var data = {
            title: title,
            composites: composites,
            count: count
        };

        $.ajax({
            url: '/cart/add/wok',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function (response) {
                debug.log(response);
                if (response.code === "200") {
                    BasketService.updateBasketInfo(response.result.count, response.result.price, response.result.maxFreeItems,
                        response.result.standardFreeItems, response.result.itemsWithIds, response.result.countPositions);

                    if (callback !== null) {
                        callback();
                    }
                } else {
                    debug.log("Error: code - " + response.code + "; msg - " + response.msg);
                }
            }
        });
    }

    const addCustomWok = (id, count) => {
        const data = {
            id: id,
            count: count
        };

        $.ajax({
            url: '/cart/add/custom-wok',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data)
        })
            .done(response => {
                if (response.code === "200") {
                    BasketService.updateBasketInfo(
                        response.result.count,
                        response.result.price,
                        response.result.maxFreeItems,
                        response.result.standardFreeItems,
                        response.result.itemsWithIds,
                        response.result.countPositions
                    );
                }
            })
    };

    function requestRepeatOrder(number, callback) {

        var data = {
            number: number
        };

        $.ajax({
            url: '/cart/repeat',
            type: 'POST',
            data: data,
            success: function (response) {
                debug.log(response);
                if (response.code === "200") {
                    BasketService.updateBasketInfo(response.result.count, response.result.price, response.result.maxFreeItems,
                        response.result.standardFreeItems, response.result.itemsWithIds, response.result.countPositions);

                    if (callback !== null) {
                        callback();
                    }
                } else {
                    debug.log("Error: code - " + response.code + "; msg - " + response.msg);
                }
            }
        });
    }

    function updateAmountPrice() {
        //$('.js-cart-price').text(info.totalPrice);
    }

    function CreateInOrderItem() {

        //************ Variables ************/
        var element = {};
        var id = "";
        var itemId = "";
        var count = 0;
        var price = 0;
        var freePrice = 0;
        var isAdditionalItem = false;
        var maxFreeCount = 0;
        let addons;

        //************ Functions ************//
        function setId(value) {
            id = value;
        }

        function getId() {
            return id;
        }

        function setItemId(value) {
            itemId = value;
        }

        function setElement(value) {
            element = value;
            count = parseInt(element.find('.js-cart-item-count').text());
            price = parseFloat(element.find('.js-cart-item-price').text());
            freePrice = parseFloat(element.find('.js-cart-item-price').data('price'));
            maxFreeCount = parseInt(element.find('.js-cart-item-count').data('max-free-count'));
            isAdditionalItem = element.data('additionalItem');
        }

        function getElement() {
            return element;
        }

        function getIsAdditionalItem() {
            return isAdditionalItem;
        }

        function setCount(value) {
            count = value;
            element.find('.js-cart-item-count').text(count);
            if (value > 0) {
                element.show();
            } else {
                element.hide();
            }
        }

        function getCount() {
            return count;
        }

        function setMaxFreeCount(value) {
            maxFreeCount = value;
            updateTotalPrice();
        }

        function updateTotalPrice() {
            element.find('.js-cart-item-total-price').text(getTotalPrice());
        }

        function getTotalPrice() {
            if (isAdditionalItem) {
                if (count > maxFreeCount) {
                    element.find('.js-cart-item-price').text(freePrice);
                    return (count - maxFreeCount) * freePrice;
                } else {
                    element.find('.js-cart-item-price').text(0);
                    return 0;
                }
            }
            return count * price;
        }

        function inc() {
            setCount(count + 1);
            updateTotalPrice();
            requestSet(id, itemId, count, addons);
        }

        function dec() {
            if (count === 1) {
                remove();
                return;
            }
            setCount(count - 1);
            updateTotalPrice();
            requestSet(id, itemId, count, addons);
        }

        function remove() {
            setCount(0);
            requestSet(id, itemId, 0, addons);
        }

        function setAddons(setAddons) {
            addons = setAddons;
        }

        function getAddons() {
            return addons;
        }

        //************ Public ************//
        return {
            setId: setId,
            getId: getId,
            getIsAdditionalItem: getIsAdditionalItem,
            setMaxFreeCount: setMaxFreeCount,
            setCount: setCount,
            getCount: getCount,
            setItemId: setItemId,
            setElement: setElement,
            getElement: getElement,
            inc: inc,
            dec: dec,
            remove: remove,
            setAddons: setAddons,
            getAddons: getAddons
        };
    }

    function ecommerceAdd(name, id, price, categoryTitle) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommerceAdd',
            'ecommerce': {
                'add': {
                    'products': [
                        {
                            'name': name,
                            'id': id,
                            'price': price,
                            'category': categoryTitle,
                            'quantity': 1
                        }
                    ]
                }
            }
        });
    }

    function ecommerceRemove(name, id, price, count, categoryTitle) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommerceRemove',
            'ecommerce': {
                'remove': {
                    'products': [
                        {
                            'name': name,
                            'id': id,
                            'price': price,
                            'category': categoryTitle,
                            'quantity': count
                        }
                    ]
                }
            }
        });
    }

    function addRecommendedItemToBasket() {
        var itemGroupId = $('.js-recommended-item')[0].dataset.itemGroupId;
        var itemId = $('.js-recommended-item')[0].dataset.itemId;
        var count = 1;
        $.post('/cart/set', {itemGroupId: itemGroupId, itemId: itemId, count: count}, function (response) {
            if (response.code === "200") {
                location.reload();
            } else {
                debug.log("Error: code - " + response.code + "; msg - " + response.msg);
            }
        })
    }

    function closeRecommendedItemSelection() {
        $('.js-recommended-item').hide();
    }

    function init() {
        $('.js-add-recommended-item').click(addRecommendedItemToBasket);
        $('.js-close-recommended-card').click(closeRecommendedItemSelection);

        $('#js-submit-change-promo-item').submit(changePromoItem);

        $('.js-cart-item').each(function () {
            var element = $(this);
            var name = element.data('name');
            var id = element.data('id');
            var price = element.find('.js-cart-item-price').data('item-price');
            var categoryTitle = element.data('category-title');
            var itemId = element.data('itemId');
            var count = element.find('.js-cart-item-count').text();
            var inOrderItem = CreateInOrderItem();
            let addons = element.data("addons");

            inOrderItem.setId(id);
            inOrderItem.setItemId(itemId);
            inOrderItem.setElement(element);
            inOrderItem.setAddons(addons);

            element.find('.js-cart-item-delete').click(function () {
                if (price != 0) {
                    ecommerceRemove(name, id, price, inOrderItem.getCount(), categoryTitle);
                }
                inOrderItem.remove();
            });
            element.find('.js-cart-item-inc').click(function () {
                if (price != 0) {
                    ecommerceAdd(name, id, price, categoryTitle);
                }
                inOrderItem.inc();
            });
            element.find('.js-cart-item-dec').click(function () {
                if (price != 0) {
                    ecommerceRemove(name, id, price, 1, categoryTitle);
                }
                inOrderItem.dec();
            });
            inOrderItems[itemId] = inOrderItem;
        });
    }

//************ Public ************//
    return {
        init: init,
        addWok: addWok,
        updateBasketInfo: updateBasketInfo,
        requestSet: requestSet,
        addCustomWok: addCustomWok,
        requestRepeatOrder: requestRepeatOrder,
        requestAddItem: requestAddItem
    };
})
();

$(BasketService.init);